/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserAccountingDto } from '../../models/center-user-accounting-dto';

export interface CenterUserControllerGetAccounting$Params {
  centerUserId: string;

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;
}

export function centerUserControllerGetAccounting(http: HttpClient, rootUrl: string, params: CenterUserControllerGetAccounting$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserAccountingDto>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerGetAccounting.PATH, 'get');
  if (params) {
    rb.query('centerUserId', params.centerUserId, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterUserAccountingDto>;
    })
  );
}

centerUserControllerGetAccounting.PATH = '/api/center-user/accounting';
